import React from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';

const HomepageLayout = props => {
  return (
    <>
      <Header {...props} />
      {props.children}
      <Footer />
    </>
  );
};

export default HomepageLayout;
